"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPixelRatioNumber = exports.queryMapToCriteria = exports.getMediaQuery = exports.TOrientation = exports.TDeviceType = void 0;
var TDeviceType;
(function (TDeviceType) {
    TDeviceType["mobile"] = "mobile";
    TDeviceType["desktop"] = "desktop";
})(TDeviceType || (exports.TDeviceType = TDeviceType = {}));
var TOrientation;
(function (TOrientation) {
    TOrientation["portrait"] = "portrait";
    TOrientation["landscape"] = "landscape";
})(TOrientation || (exports.TOrientation = TOrientation = {}));
const getMediaQuery = (meta, string) => {
    var _a, _b, _c, _d;
    if (!meta) {
        const pixelRatioNumber = (0, exports.extractPixelRatioNumber)(string);
        return [
            pixelRatioNumber > 0 &&
                `(-webkit-min-device-pixel-ratio: ${pixelRatioNumber})`,
            string.includes('mobile') && `(orientation: ${TOrientation.portrait})`,
            string.includes('desktop') && `(orientation: ${TOrientation.landscape})`,
        ]
            .filter(Boolean)
            .join(` and `);
    }
    return [
        (meta === null || meta === void 0 ? void 0 : meta.orientation) && `(orientation: ${meta.orientation})`,
        ((_a = meta === null || meta === void 0 ? void 0 : meta.q) === null || _a === void 0 ? void 0 : _a.minW) && `(min-width: ${meta === null || meta === void 0 ? void 0 : meta.q.minW}px)`,
        ((_b = meta === null || meta === void 0 ? void 0 : meta.q) === null || _b === void 0 ? void 0 : _b.maxW) && `(max-width: ${meta === null || meta === void 0 ? void 0 : meta.q.maxW}px)`,
        ((_c = meta === null || meta === void 0 ? void 0 : meta.q) === null || _c === void 0 ? void 0 : _c.minH) && `(min-height: ${meta === null || meta === void 0 ? void 0 : meta.q.minH}px)`,
        ((_d = meta === null || meta === void 0 ? void 0 : meta.q) === null || _d === void 0 ? void 0 : _d.maxH) && `(max-height: ${meta === null || meta === void 0 ? void 0 : meta.q.maxH}px)`,
    ]
        .filter(Boolean)
        .join(` and `);
};
exports.getMediaQuery = getMediaQuery;
const queryMapToCriteria = (queryMap, update) => [...Array.from(queryMap.entries())].map(([id, { s, resizingType }]) => {
    var _a, _b;
    return (Object.assign(Object.assign({ id }, (((_a = update === null || update === void 0 ? void 0 : update.get(id)) === null || _a === void 0 ? void 0 : _a.s) || s)), { resizingType: ((_b = update === null || update === void 0 ? void 0 : update.get(id)) === null || _b === void 0 ? void 0 : _b.resizingType) || resizingType }));
});
exports.queryMapToCriteria = queryMapToCriteria;
const extractPixelRatioNumber = (id) => {
    const match = id.match(/\d+(\.\d+)?x/); // checks if the string contains "1x", "1.25x", "2x", etc.
    return match ? Number(match[0].split('x')[0]) : NaN;
};
exports.extractPixelRatioNumber = extractPixelRatioNumber;
//# sourceMappingURL=bs-picture.utils.js.map